import React from "react";

export default function JobHunting() {
  return (
    <div>
      <p>
        As we leave 2023 behind, it's time to dust off our resumes and take
        stock of the whirlwind that was this year's job market. It was a year of
        surprises, shifts, and challenges, yet also resilience, adaptation, and
        opportunities. Let's unpack some key insights:
      </p>
      <h3>Overview</h3>
      <p>
        Post-pandemic boom hangover: 2023 started with the roaring fire of a
        post-pandemic hiring frenzy, but gradually shifted to a more normalized
        pace. Job vacancies remained above pre-pandemic levels, but growth
        slowed down, reflecting economic uncertainties.
      </p>
    </div>
  );
}
